import { useListCampaignBenefits } from '@givebacks/api/store';
import { BenefitDetailsModalCard, BenefitsListModalButton } from '@givebacks/shop';
import { SimpleGrid, Stack, Title, Transition } from 'ui';

const Benefits = ({
  campaignId,
  causeId,
  benefitsTitle,
}: {
  campaignId: string;
  causeId: string;
  benefitsTitle: string;
}) => {
  const { data: benefits } = useListCampaignBenefits({
    campaignId: campaignId,
    causeId: causeId,
    queryOptions: {
      searches: {
        deleted: { value: false },
      },
    },
  });

  const hasBenefits = benefits?.store_items?.length;

  return (
    <Transition.Element mounted={!!hasBenefits} transition="fade">
      <Stack mih={296} maw={{ base: '100%', md: 684 }}>
        <Title order={2} tt="capitalize">
          {benefitsTitle}
        </Title>
        <SimpleGrid cols={{ base: 1, xs: 2, sm: 3 }}>
          {benefits?.store_items
            .filter((_, index) => index < 3)
            .map((benefit) => (
              <BenefitDetailsModalCard
                campaignId={campaignId}
                key={benefit.uuid}
                title={benefit.name}
                description={benefit.content.description}
                price={benefit.price}
                image={benefit?.images?.[0]?.url}
                storeId={causeId}
                storeItemId={benefit.uuid}
              />
            ))}
        </SimpleGrid>
        {hasBenefits && hasBenefits > 3 && (
          <BenefitsListModalButton
            campaignId={campaignId}
            causeId={causeId}
            benefitsTitle={benefitsTitle}
          />
        )}
      </Stack>
    </Transition.Element>
  );
};

export { Benefits };
